import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalStoreService } from 'src/app/shared/_services/global-store.service';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};

  constructor(public router: Router, public spinner: NgxSpinnerService, public globalStore: GlobalStoreService) { }
  //TODO: modificare se serve la sidebar di settings
  hasCustomizer = environment['hasCustomizer'];
  tabStatus = 'justified';

  public isCollapsed = false;
  public fullScreen = false;
  public innerWidth: any;
  public defaultSidebar: any;
  public showSettings = false;
  public showMobileMenu = false;
  public expandLogo = false;
  fourthLayerItems: any = null

  options = {
    theme: environment.theme ?? 'light', // two possible values: light, dark
    dir: environment.dir?? 'ltr', // two possible values: ltr, rtl
    layout: environment.layout ?? 'vertical', // fixed value. shouldn't be changed.
    sidebartype: environment.sidebartype ?? 'full', // four possible values: full, iconbar, overlay, mini-sidebar
    sidebarpos: environment.sidebarpos ?? 'fixed', // two possible values: fixed, absolute
    headerpos: environment.headerpos ?? 'fixed', // two possible values: fixed, absolute
    boxed: environment.boxed ?? 'full', // two possible values: full, boxed
    navbarbg: environment.navbarbg ?? 'skin1', // six possible values: skin(1/2/3/4/5/6)
    sidebarbg: environment.sidebarbg , // six possible values: skin(1/2/3/4/5/6)
    logobg: environment.logoBg , // six possible values: skin(1/2/3/4/5/6)
    logoPath: environment.logoPath
  };

  Logo() {
    this.expandLogo = !this.expandLogo;
  }

  ngOnInit() {
    if (this.router.url === '/') {
      this.router.navigate(['/Login']);
    }
    this.defaultSidebar = this.options.sidebartype;
    this.handleSidebar();
    this.globalStore.$fullscreen.subscribe(fullscreen => this.fullScreen = fullscreen)
  }

  showSpinner() {
    this.spinner.spinnerObservable.subscribe(spinner => {
      spinner.fullScreen = true;
    })

    this.globalStore
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
    this.handleSidebar();
  }
  

  handleSidebar() {
    this.innerWidth = window.innerWidth;
    switch (this.defaultSidebar) {
      case 'full':
      case 'iconbar':
        if (this.innerWidth < 1170) {
          this.options.sidebartype = 'mini-sidebar';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      case 'overlay':
        if (this.innerWidth < 767) {
          this.options.sidebartype = 'mini-sidebar';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default:
    }
  }

  toggleSidebarType() {
    switch (this.options.sidebartype) {
      case 'full':
      case 'iconbar':
        this.options.sidebartype = 'mini-sidebar';
        break;

      case 'overlay':
        this.showMobileMenu = !this.showMobileMenu;
        break;

      case 'mini-sidebar':
        if (this.defaultSidebar === 'mini-sidebar') {
          this.options.sidebartype = 'full';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default:
    }
  }
  handleClick(event: boolean) {
    this.showMobileMenu = event;
  }



  @HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent) {
  const target = event.target as HTMLElement;

  // Se il clic è dentro la sidebar o sul toggler, non fare nulla
  const clickedInsideSidebar = target.closest('.left-sidebar');
  const clickedToggle = target.closest('.nav-toggler');

  if (!clickedInsideSidebar && !clickedToggle && this.showMobileMenu && this.innerWidth < 768) {
    this.showMobileMenu = false;
  }
}

  closeFullScreenMode(){
    this.globalStore.setFullScreen(false);
  }

 environment = environment;
}
